"use client";

import useSWR from "swr";
import { useAuth } from "@clerk/nextjs";
import { useCallback } from "react";

const NOTIFICATIONS_KEY = "/api/notifications";

export function useNotifications(options?: { unreadOnly?: boolean }) {
  const { isLoaded, userId } = useAuth();
  const shouldFetch = isLoaded && userId;

  const unreadOnly = options?.unreadOnly ?? false;
  const key = shouldFetch
    ? `${NOTIFICATIONS_KEY}?limit=20&unreadOnly=${unreadOnly}`
    : null;

  const { data, error, isLoading, mutate } = useSWR(key, {
    refreshInterval: 30_000,
    revalidateOnFocus: false,
  });

  const markAsRead = useCallback(
    async (notificationId: string) => {
      await fetch(NOTIFICATIONS_KEY, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "read", notificationId }),
      });
      mutate();
    },
    [mutate],
  );

  const markAllAsRead = useCallback(async () => {
    await fetch(NOTIFICATIONS_KEY, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "read-all" }),
    });
    mutate();
  }, [mutate]);

  return {
    notifications: data?.data?.notifications || [],
    unreadCount: data?.data?.unreadCount ?? 0,
    nextCursor: data?.data?.nextCursor || null,
    isLoading: !shouldFetch || (isLoading && !data),
    error: error?.message || null,
    mutate,
    markAsRead,
    markAllAsRead,
  };
}
